export default "/images/sonderjysk-cropped.avif?a857142178ad9f085d1124f3aa673782";